import React from 'react';
import { LANGS } from './langs';

const LangSelector = ({ value, onChange }) => (
  <div className="visite-lang-selector" role="group" aria-label="Langues">
    {LANGS.map((l) => (
      <button
        key={l.code}
        type="button"
        className={`visite-lang-btn ${value === l.code ? 'is-active' : ''}`}
        aria-pressed={value === l.code}
        onClick={() => onChange(l.code)}
      >
        {l.label}
      </button>
    ))}
  </div>
);

export default LangSelector;
